import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const DotMenuButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content;
`;
const MenuButton = styled.button`
  position: relative;
  z-index: 1000;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;
const DropdownMenu = styled.ul`
  transition: all 100ms ease-in-out;
  overflow: hidden;
  box-sizing: border-box;
  position: absolute;
  top: 100%;
  right: 0%;
  background-color: #333;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
  max-height: 0;

  padding: 0;
  &.open {
    max-height: 100px;
  }
  &.close {
    max-height: 0;
  }

  li button {
    background: none;
    border: none;
    width: 100%;
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: left;
    list-style: none;
    padding: 10px;
    cursor: pointer;
    color: #fff;
    white-space: nowrap;
  }

  li button:hover {
    background-color: #f0f0f0;
    color: #000;
    > svg {
      color: #000;
    }
  }
  li button svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #fff;
  }

  .open {
    max-height: 200px; /* 충분한 높이값 설정 */
    padding: 10px;
  }

  .close {
    max-height: 0;
    padding: 0;
  }

  @media (max-width: 600px) {
    li button {
      font-size: 12px;
    }
    li button svg {
      width: 16px;
      height: 16px;
    }
  }
`;
// 아이콘들
const DeleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-trash"
    viewBox="0 0 16 16"
  >
    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
  </svg>
);
const EditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-pencil-square"
    viewBox="0 0 16 16"
  >
    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
    <path
      fillRule="evenodd"
      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
    />
  </svg>
);
const DotMenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-three-dots-vertical"
    viewBox="0 0 16 16"
  >
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
);

export default function DotMenuButton({ handleEditClick, handleDeleteClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // 메뉴 열림 상태
  const menuRef = useRef(null); // 메뉴 참조

  // 메뉴 외부 클릭 시 메뉴 닫기
  useEffect(() => {
    if (!isMenuOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  // 메뉴 클릭 시 메뉴 열림
  const onMenuClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <DotMenuButtonContainer ref={menuRef}>
      <MenuButton aria-label="메뉴" onClick={(e) => onMenuClick(e)}>
        {DotMenuIcon}
      </MenuButton>
      {isMenuOpen && (
        <DropdownMenu className={`${isMenuOpen ? "open" : "close"}`}>
          <li>
            <button onClick={(e) => handleEditClick(e)}>
              {EditIcon}
              <span>수정</span>
            </button>
          </li>
          <li>
            <button onClick={(e) => handleDeleteClick(e)}>
              {DeleteIcon}
              <span>삭제</span>
            </button>
          </li>
        </DropdownMenu>
      )}
    </DotMenuButtonContainer>
  );
}
